import { type ActionReducerMapBuilder, createReducer } from '@reduxjs/toolkit';

import { closeDrawer, showConfirmRemoveItemDrawer } from '../actions/drawers-actions';

export type DrawersPayloads = {
  showConfirmRemoveItemDrawer: { onConfirm: () => Promise<void> };
};

export type DrawersState = {
  confirmRemoveItemDrawer: { onConfirm: () => Promise<void> } | null;
};

export const drawersInitialState: DrawersState = {
  confirmRemoveItemDrawer: null,
};

export const drawersReducer = createReducer(drawersInitialState, (builder: ActionReducerMapBuilder<DrawersState>) => {
  builder.addCase(showConfirmRemoveItemDrawer, (_state, action) => ({
    ...drawersInitialState,
    confirmRemoveItemDrawer: action.payload,
  }));
  builder.addCase(closeDrawer, (state, action) => {
    if (Object.keys(drawersInitialState).includes(action.payload)) {
      return {
        ...state,
        [action.payload]: null,
      };
    }

    return state;
  });
});
